/* eslint-disable no-undef */
import SelectCore from './SelectCore';
import { getRemoteDefaultValues } from './utils/remoteDefaultValues';

class SelectIndustries extends SelectCore {
  componentDidMount() {
    const { defaultValue, networkId, onChange } = this.props;

    window
      .select2_industries($(this.select), {
        placeholder: this.defaultPlaceholder(),
        network_id: networkId,
        minimumInputLength: 0,
      })
      .on('change', onChange);

    if (defaultValue?.length > 0) {
      getRemoteDefaultValues({
        searchUrl: Routes.search_industries_path({ ids: defaultValue }),
        selectElement: $(this.select),
      });
    }
  }

  componentDidUpdate() {
    window.select2_industries($(this.select), {
      placeholder: this.defaultPlaceholder(),
    });
  }

  defaultPlaceholder = () => {
    const { placeholder } = this.props;

    return placeholder || I18n.t('web.users.search.industries');
  };
}

export default SelectIndustries;
